module.exports = __webpack_public_path__ + "img/pin-safira.93f30f1e.png";